import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './new.routes';
import addHtml from './modal/add.html';

export class NewController {
    $http;
    socket;
    news = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;

        this.isHot = [
            { value: 0, name: '否' },
            { value: 1, name: '是' }
        ]

        this.newsType = [
            { value: 1, name: '新闻' },
            { value: 2, name: '学习' }
        ]



        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('news');
        });
    }

    TransformationIsHot(value) {
        var ret = _.find(this.isHot, { value: value });
        if (ret) {
            return ret.name;
        }
        return '';
    }

    TransformationNewsType(value) {
        var ret = _.find(this.newsType, { value: value });
        if (ret) {
            return ret.name;
        }
        return '';
    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/news/?all=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;
                        angular.forEach(response.data.data, function (item) {
                            if (item.img.indexOf('[') !== -1) {
                                item.img = JSON.parse(item.img);
                            } else {
                                item.img = [item.img];
                            }
                        });
                        this.news = response.data.data;

                        this.socket.syncUpdates('news', this.news);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }

        const payload = angular.copy(this.filters);

        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/news/?all=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        angular.forEach(response.data.data, function (item) {
                            if (item.img.indexOf('[') !== -1) {
                                item.img = JSON.parse(item.img);
                            } else {
                                item.img = [item.img];
                            }
                        });
                        this.news = response.data.data;

                        this.socket.syncUpdates('news', this.news);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    getContent(content) {
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.content = content;
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
    }
}

export default angular.module('tttApp.new', [uiRouter])
    .config(routing)
    .component('new', {
        template: require('./new.html'),
        controller: NewController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/new/new.component.js